function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M248.1 81.3l-8.1 25h-38.7v15.6l-12.3-7.2-20.8 20.8 33.1 19.4v10.8l-9.8 18.6V255h-14.4v-70.8h-57.5l-28.5 28.5h57.8v70.8H220v-92.2l9.8-18.5v-38h30.9l22.8-70.5-31.9-12.2-22.1 22.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.1 283.5v-20.2l28.5-28.4V127.5h107.3l28.7-28.7 17.9-51.1 18.1 15.1L222.5 41l-6.6-2.5L169 0l-34.6 98.8H28.5V63.6H0l.1 219.9h71v-50.9l-50.8 50.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.8 220.7l36.4-36.5H42.8zM10.4 262.9l10.7 9.9L276.3 17 266 6.9z"
})));